import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

const markConversationAsRead = (conversations, conversation_id) => {
    if (!conversation_id) {
        return conversations;
    }
    
    return conversations.map(conversation => ({
        ...conversation,
        read: conversation_id === conversation.id ? true : conversation.read
    }))
}

function textReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.PHONE_TEXT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingPhones: true, phones: [] };
        case getNamedAction(ACTION_NAMES.PHONE_TEXT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingPhones: false, phones: action.data };
        case getNamedAction(ACTION_NAMES.PHONE_TEXT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingPhones: false, phones: [] };

        case getNamedAction(ACTION_NAMES.CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingConversations: true, conversations: [], conversations_count: 0 };
        case getNamedAction(ACTION_NAMES.CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingConversations: false, conversations: action.data.data, conversations_count: action.data.count };
        case getNamedAction(ACTION_NAMES.CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingConversations: false, conversations: [], conversations_count: 0 };

        case getNamedAction(ACTION_NAMES.TEXT_PANEL_CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingTextPanelConversations: true, textPanelConversations: [], textPanelConversations_count: 0 };
        case getNamedAction(ACTION_NAMES.TEXT_PANEL_CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingTextPanelConversations: false, textPanelConversations: action.data.data, textPanelConversations_count: action.data.count };
        case getNamedAction(ACTION_NAMES.TEXT_PANEL_CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingTextPanelConversations: false, textPanelConversations: [], textPanelConversations_count: 0 };

        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_TEXT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingMessages: true, filteredMessages: [], messages_count: 0 };
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_TEXT, CRUD_ACTION_TYPES.READ_SUCCESS):
            {
                const { data, count, conversation_id } = action.data;
                return { ...state, isReadingMessages: false, filteredMessages: data || [], userOptions: action.data.userOptions, filtered_messages_count: count, 
                    conversations: markConversationAsRead(state.conversations, conversation_id),
                    textPanelConversations: markConversationAsRead(state.textPanelConversations, conversation_id)
                };
            }
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_TEXT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingMessages: false, messages: [], message_count: 0 };

        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_OFFICE_VIEW, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingMessagesForTextOfficeView: true, filteredMessagesForTextOfficeView: [], filtered_messages_count_for_text_office_view: 0, textOfficeViewUserOptions: [] };
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_OFFICE_VIEW, CRUD_ACTION_TYPES.READ_SUCCESS):
            {
                const { data, count, userOptions, conversation_id } = action.data;
                return { ...state, isReadingMessagesForTextOfficeView: false, filteredMessagesForTextOfficeView: data || [], filtered_messages_count_for_text_office_view: count, textOfficeViewUserOptions: userOptions,
                    conversations: markConversationAsRead(state.conversations, conversation_id),
                    textHistoryConversations: markConversationAsRead(state.textHistoryConversations, conversation_id)
                };
            }
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_OFFICE_VIEW, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingMessagesForTextOfficeView: false, filteredMessagesForTextOfficeView: [], filtered_messages_count_for_text_office_view: 0 };

        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_PANEL, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingMessagesForTextPanel: true, filteredMessagesForTextPanel: [], filtered_messages_count_for_text_panel: 0, textPanelUserOptions: [] };
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_PANEL, CRUD_ACTION_TYPES.READ_SUCCESS):
            {
                const { data, count, userOptions, conversation_id } = action.data;
                return { ...state, isReadingMessagesForTextPanel: false, filteredMessagesForTextPanel: data || [], filtered_messages_count_for_text_panel: count, textPanelUserOptions: userOptions,
                    textPanelConversations: markConversationAsRead(state.textPanelConversations, conversation_id),
                    textHistoryConversations: markConversationAsRead(state.textHistoryConversations, conversation_id),
                    conversations: markConversationAsRead(state.conversations, conversation_id)
                };
            }
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_PANEL, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingMessagesForTextPanel: false, filteredMessagesForTextPanel: [], filtered_messages_count_for_text_panel: 0, textPanelUserOptions: [] };

        case getNamedAction(ACTION_NAMES.TEXT_CONTACT_INFO, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingContact: true }
        case getNamedAction(ACTION_NAMES.TEXT_CONTACT_INFO, CRUD_ACTION_TYPES.READ_ONE_SUCCESS): {
            const { contact } = action.data;
            const { email, phone, first_name, last_name, suffix, primary_location_id, locations } = contact;

            return {
                ...state,
                contact: { contact: { first_name, last_name, suffix, primary_location_id }, locations, 
                    email: (email || { data: [] }).data,
                    phone: (phone || { data: [] }).data, 
                },
                
                isReadingContact: false
            }
        }
        case getNamedAction(ACTION_NAMES.TEXT_CONTACT_INFO, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingContact: false, contact: { contact: {} } }

        case getNamedAction(ACTION_NAMES.TEXT_ACCOUNT_INFO, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingAccount: true }
        case getNamedAction(ACTION_NAMES.TEXT_ACCOUNT_INFO, CRUD_ACTION_TYPES.READ_ONE_SUCCESS): {
            return {
                ...state, 
                isReadingAccount: false,
                account: action.data
            }
        }
        case getNamedAction(ACTION_NAMES.TEXT_ACCOUNT_INFO, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingAccount: false, account: {} }

        case getNamedAction(ACTION_NAMES.TEXT_RECIPIENT_PHONES, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingRecipientPhones: true, recipientPhones: [] };
        case getNamedAction(ACTION_NAMES.TEXT_RECIPIENT_PHONES, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, recipientPhones: action.data.data, isReadingRecipientPhones: false };
        case getNamedAction(ACTION_NAMES.TEXT_RECIPIENT_PHONES, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, recipientPhones: [], isReadingRecipientPhones: false };

        case getNamedAction(ACTION_NAMES.OFFICE_VIEW_TEXT_CONTACT_INFO, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingOfficeViewContact: true, officeViewContact: { contact: {} } }
        case getNamedAction(ACTION_NAMES.OFFICE_VIEW_TEXT_CONTACT_INFO, CRUD_ACTION_TYPES.READ_ONE_SUCCESS): {
            const { contact } = action.data;
            const { email, phone, first_name, last_name, suffix, primary_location_id, locations } = contact;

            return {
                ...state,
                officeViewContact: { contact: { first_name, last_name, suffix, primary_location_id }, locations, 
                    email: (email || { data: [] }).data,
                    phone: (phone || { data: [] }).data, 
                },
                
                isReadingOfficeViewContact: false
            }
        }
        case getNamedAction(ACTION_NAMES.OFFICE_VIEW_TEXT_CONTACT_INFO, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingOfficeViewContact: false, officeViewContact: { contact: {} } }

        case getNamedAction(ACTION_NAMES.TEXT, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isSendingText: true };
        case getNamedAction(ACTION_NAMES.TEXT, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isSendingText: false };
        case getNamedAction(ACTION_NAMES.TEXT, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isSendingText: false };

        case getNamedAction(ACTION_NAMES.TEXT_LOGS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingLogs: true, logs: [], billableTextMessageCount:0, count:0 };
        case getNamedAction(ACTION_NAMES.TEXT_LOGS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingLogs: false, logs: action.data.data, billableTextMessageCount: action.data.text_message_count, count: action.data.count };
        case getNamedAction(ACTION_NAMES.TEXT_LOGS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingLogs: false, logs: [], billableTextMessageCount:0, count:0 };
        
        case getNamedAction(ACTION_NAMES.TEXT_USERS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingTextUsers: true, textUsers: [] };
        case getNamedAction(ACTION_NAMES.TEXT_USERS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingTextUsers: false, textUsers: action.data };
        case getNamedAction(ACTION_NAMES.TEXT_USERS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingTextUsers: false, textUsers: [] };

        case ACTION_NAMES.SET_TEXT_PANEL_QUERY_PARAMETERS:
            return { ...state, textPanelQuery: action.query };
        
        case ACTION_NAMES.SET_TEXT_PANEL_CONVERSATION_BEING_VIEWED:
            return { ...state, textPanelConversationRecipient: action.contact_phone, textPanelConversationSender: action.customer_phone, textPanelRecipientId: action.recipientId, textPanelRecipientType: action.recipientType, textPanelRecipientName: action.recipientName };

        case ACTION_NAMES.SET_TEXT_TAB_CONVERSATION_BEING_VIEWED:
            return { ...state, textTabConversationRecipient: action.contact_phone, textTabConversationSender: action.customer_phone, textTabLogId: action.log_id };

        case ACTION_NAMES.SET_OFFICE_VIEW_CONVERSATION_BEING_VIEWED:
            return { ...state, officeViewConversationRecipient: action.contact_phone, officeViewConversationSender: action.customer_phone };

        case ACTION_NAMES.SET_TEXT_HISTORY_CONVERSATION_BEING_VIEWED:
            return { ...state, textHistoryConversationRecipient: action.contact_phone, textHistoryConversationSender: action.customer_phone, textHistoryRecipientId: action.recipientId, textHistoryRecipientType: action.recipientType, textHistoryRecipientName: action.recipientName };

        case getNamedAction(ACTION_NAMES.CONTACT_PHONE_TEXT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingContactPhones: true, contactPhones: [] };
        case getNamedAction(ACTION_NAMES.CONTACT_PHONE_TEXT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingContactPhones: false, contactPhones: action.data };
        case getNamedAction(ACTION_NAMES.CONTACT_PHONE_TEXT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingContactPhones: false, contactPhones: [] };

        case getNamedAction(ACTION_NAMES.TEXT_HISTORY_CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingTextHistoryConversations: true, textHistoryConversations: [], textHistoryConversations_count: 0 };
        case getNamedAction(ACTION_NAMES.TEXT_HISTORY_CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingTextHistoryConversations: false, textHistoryConversations: action.data.data, textHistoryConversations_count: action.data.count };
        case getNamedAction(ACTION_NAMES.TEXT_HISTORY_CONVERSATION_TEXT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingTextHistoryConversations: false, textHistoryConversations: [], textHistoryConversations_count: 0 };

        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_HISTORY, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingMessagesForTextHistory: true, filteredMessagesForTextHistory: [], filtered_messages_count_for_text_history: 0, textHistoryUserOptions: [] };
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_HISTORY, CRUD_ACTION_TYPES.READ_SUCCESS):
            {
                const { data, count, userOptions, conversation_id } = action.data;
                return { ...state, isReadingMessagesForTextHistory: false, filteredMessagesForTextHistory: data || [], filtered_messages_count_for_text_history: count, textHistoryUserOptions: userOptions,
                    textPanelConversations: markConversationAsRead(state.textPanelConversations, conversation_id),
                    textHistoryConversations: markConversationAsRead(state.textHistoryConversations, conversation_id)
                };
            }
        case getNamedAction(ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_HISTORY, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingMessagesForTextHistory: false, filteredMessagesForTextHistory: [], filtered_messages_count_for_text_history: 0, textHistoryUserOptions: [] };

        case getNamedAction(ACTION_NAMES.TEXT_UNSUBSCRIBED, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingUnsubscribedPhones: true, unsubscribedPhones: [] };
        case getNamedAction(ACTION_NAMES.TEXT_UNSUBSCRIBED, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingUnsubscribedPhones: false, unsubscribedPhones: action.data };
        case getNamedAction(ACTION_NAMES.TEXT_UNSUBSCRIBED, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingUnsubscribedPhones: false, unsubscribedPhones: [] };

        case getNamedAction(ACTION_NAMES.START_BULK_TEXTING, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isStartingBulkTexting: true };
        case getNamedAction(ACTION_NAMES.START_BULK_TEXTING, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isStartingBulkTexting: false };
        case getNamedAction(ACTION_NAMES.START_BULK_TEXTING, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isStartingBulkTexting: false };

        default:
            return state;
    }
}

export default textReducer;
